import { URL_EXCLUSION_LIST_CERT_DETAILS_API } from '../redux/certdetails/urls';
import { checkEnvironment, getCertsMSconfigFromStore } from '../utils/utils';

/**
 * Certs MS UI changes
 */
const exceptionURLsList = [...URL_EXCLUSION_LIST_CERT_DETAILS_API];

export const getBaseURL = (url) => {
  const certsMSconfigFromStore = getCertsMSconfigFromStore();
  const { GATEWAY_API_URL, ECM_URL } = checkEnvironment();

  let isNotCertMs = Boolean(
    exceptionURLsList.some(
      (endpoint) => url === endpoint || Number(certsMSconfigFromStore) !== 1
    )
  );

  // Check if source URL contains 'certification/details' and exception URL contains '/certifications/v2/items/auditHistory'
  if (
    window.location.href.includes('/certification/details') &&
    url.includes('/certifications/v2/items/auditHistory')
  ) {
    isNotCertMs = false;
  }

  if (isNotCertMs) return ECM_URL;

  return `${GATEWAY_API_URL}/api/certms`;
};

export default getBaseURL;
